import { Inject, Injectable } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import Env from '../../env';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';

enum ThemeStyle {
    Dark = 'dark',
    Light = 'light'
}

@Injectable({
    providedIn: 'root'
})
export class StatusBarService {
    private handleToggleStatusBar = new Subject();
    public handleToggleStatusBar$ = this.handleToggleStatusBar.asObservable();

    private readonly defaultLightBackgroundColor = '#FFFFFF';
    private readonly defaultDarkBackgroundColor = '#000000';

    constructor(
        @Inject('ENV') private env: Env,
        @Inject(DOCUMENT) private document: Document
    ) {}

    private get isDarkTheme() {
        const theme = localStorage.getItem('theme');
        return theme === ThemeStyle.Dark;
    }

    public hideStatusBar() {
        this.handleToggleStatusBar.next();
    }

    public showStatusBar() {
        this.handleToggleStatusBar.next(true);
    }

    public overlayForAndroid(): void {
        if (Capacitor.isPluginAvailable('StatusBar')) {
            StatusBar.setOverlaysWebView({ overlay: true });
        }
    }

    public checkToSpecificPath(path: string): void {
        const isExplorePath = path.includes('explore');

        if (!this.isDarkTheme && this.env.STATUS_BAR?.WHITE_BAR_ICON_LIGHT) {
            const isContainPath = this.env.STATUS_BAR?.WHITE_BAR_ICON_LIGHT.some((p) => path.includes(p));
            this.changeStatusBarStyle(isContainPath ? Style.Dark : undefined);
        }

        if (this.isDarkTheme) {
            this.setStatusColor(this.defaultDarkBackgroundColor);
            this.changeStatusBarStyle(isExplorePath ? Style.Light : undefined);
            return;
        }

        const specificPaths = this.env.STATUS_BAR?.SPECIFIC_PATHS ?? {};
        const matchedPath = Object.keys(specificPaths).find((key) => path.includes(key));

        this.setStatusColor(matchedPath ? specificPaths[matchedPath] : this.defaultLightBackgroundColor);
    }

    public changeStatusBarStyle(style?: Style): void {
        if (Capacitor.isPluginAvailable('StatusBar')) {
            StatusBar.setStyle({ style: style || (this.isDarkTheme ? Style.Dark : Style.Light) });
        }
    }

    public setStatusColor(color: string): void {
        if (Capacitor.isNativePlatform()) {
            this.document.body.style.backgroundColor = color;
        }
    }
}
